import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import AdsConfigV2 from './containers/AdsConfigV2';
import Payouts from './containers/Payouts';

const Publishers = {
  Helmet: lazy(() => import('./components/Helmet')),
  AdsConfig: lazy(() => import('./containers/AdsConfig')),
  Overview: lazy(() => import('./containers/Overview')),
  Campaigns: lazyNamed(() => import('./containers/Campaigns'), 'Campaigns'),
  Payouts,
  Layout: lazy(() => import('./components/Layout')),
  Exclusions: {
    ExcludedCampaigns: lazy(() => import('./containers/Exclusions/containers/ExcludedCampaigns')),
    ExcludedCustomers: lazy(() => import('./containers/Exclusions/containers/ExcludedCustomers')),
    Layout: lazy(() => import('./containers/Exclusions/components/Layout')),
  },
  Traffic: {
    Layout: lazy(() => import('./containers/Traffic/components/Layout')),
    TrafficDashboard: lazyNamed(() => import('./containers/Traffic/containers/TrafficDashboard'), 'TrafficDashboard'),
    PlacementGroups: lazyNamed(() => import('./containers/Traffic/containers/PlacementGroups'), 'PlacementGroups'),
  },
  AdsConfigV2,
};

export default Publishers;
